import React from 'react';
import './Footer.css';
import logoIconWhite from '../images/iconcompletewhite.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src={logoIconWhite} alt="Hunter Digital Solutions" className="footer-logo-image" />
            </div>
            <p className="footer-about">
              Your trusted partner for digital marketing solutions that deliver 
              measurable growth and real results for your business.
            </p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#services">Services</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><a href="#services">Ad Management</a></li>
              <li><a href="#services">Website Development</a></li>
              <li><a href="#services">Social Media</a></li>
              <li><a href="#services">Digital Artworks</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Legal</h4>
            <ul className="footer-links">
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/terms">Terms of Service</a></li>
              <li><a href="/cookies">Cookie Policy</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 HUNTER. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;